import React, { useEffect, useState } from 'react';
import { useNotifications } from '../hooks/useNotifications';
import apiService from '../services/api';

interface NotificationProviderProps {
  children: React.ReactNode;
}

/**
 * NotificationProvider - Manages FCM notifications for authenticated users
 * Automatically requests permission and registers token when user logs in
 */
const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const { requestPermission, lastNotification, clearToken } = useNotifications();
  const [hasRequestedPermission, setHasRequestedPermission] = useState(false);

  useEffect(() => {
    const isAuthenticated = apiService.isAuthenticated();

    // Request notification permission when user is authenticated
    if (isAuthenticated && !hasRequestedPermission) {
      // Wait a bit before requesting permission (better UX)
      const timer = setTimeout(() => {
        requestPermission();
        setHasRequestedPermission(true);
      }, 2000);

      return () => clearTimeout(timer);
    }

    // Clear token when user logs out
    if (!isAuthenticated && hasRequestedPermission) {
      clearToken();
      setHasRequestedPermission(false);
    }
  }, [hasRequestedPermission, requestPermission, clearToken]);

  // Handle incoming notifications
  useEffect(() => {
    if (lastNotification) {
      // You can add custom UI notification handling here
      // For example, showing a toast notification
      if (lastNotification.notification) {
        const { title, body } = lastNotification.notification;
      }
    }
  }, [lastNotification]);

  return <>{children}</>;
};

export default NotificationProvider;
